<template>
	<div id="client_profile_page_wrapper">
		<div class="bb-mobile-header">
			<div class="bb-mobile-header-left">
				<router-link :to="{ name: 'clients' }">
					<button class="mobile-sidebar-btn">
						<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#253342" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-left">
							<line x1="19" y1="12" x2="5" y2="12"></line>
							<polyline points="12 19 5 12 12 5"></polyline>
						</svg>
					</button>
				</router-link>
			</div>
			<h1>{{ $t("clientProfile.title") }}</h1>
			<div class="bb-mobile-header-right">
				<button class="mobile-client-profile-actions-btn" @click="showMobileActions">
					<i class="ki ki-more-ver"></i>
				</button>
			</div>
		</div>
		<div class="d-flex client-profile-content">
			<div class="bb-card bb-client-profile-card mr-5 align-self-baseline">
				<div class="bb-profile-card-header">
					<div class="bb-badge badge-lg">
						{{ client.initials }}
					</div>
					<p>
						{{
              clientType == "physicalEntity" ? client.fullName : client.firmName
            }}
					</p>
				</div>
				<div class="d-flex justify-content-between align-items-center">
					<BBDropdown positionClass="left">
						<template v-slot:toggle>
							<button class="bb-btn btn-lg btn-success">
								{{ $t("clientProfile.createAppointmentDropdown.toggleBtn") }}
							</button>
						</template>
						<template v-slot:items>
							<button @click="
                  createAppointment({ clientId: client.id, date: new Date() })
                " class="w-100">
								{{
                  $t("clientProfile.createAppointmentDropdown.appointmentBtn")
                }}
							</button>
							<button @click="
                  createAppointment({
                    clientIds: [client.id],
                    date: new Date(),
                    type: 'GROUP',
                  })
                " class="w-100">
								{{
                  $t(
                    "clientProfile.createAppointmentDropdown.groupAppointmentBtn"
                  )
                }}
							</button>
						</template>
					</BBDropdown>
					<BBDropdown positionClass="right" class="client-actions-dropdown">
						<template v-slot:toggle>
							<button class="bb-btn btn-lg bb-client-profile-actions-btn">
								<i class="ki ki-more-ver"></i>
							</button>
						</template>
						<template v-slot:items>
							<div class="action-item" @click="clientType == 'physicalEntity'
                    				? editPhysicalEntity(client)
									: editLegalEntity(client) ">
								<span>{{ $t("clientProfile.dropdown.editBtn") }}</span>
							</div>
							<div class="action-item danger" @click="deleteClient()">
								<span>{{ $t("clientProfile.dropdown.deleteBtn") }}</span>
							</div>
						</template>
					</BBDropdown>
					<div class="client-profile-contact-buttons">
						<a v-if="client.phone" :href="'tel:' + client.phone">
							<i class="fas fa-phone-alt"></i>
						</a>
						<a v-if="client.email" :href="'mailto:' + client.email">
							<i class="flaticon2-black-back-closed-envelope-shape"></i>
						</a>
					</div>
				</div>
				<!-- Details -->
				<div class="bb-client-profile-card-info">
					<div class="bb-client-profile-info-item">
						<label>{{ $t("clientProfile.infoCard.email.label") }}</label>
						<span>{{ client.email }}</span>
					</div>
					<div class="bb-client-profile-info-item">
						<label>{{ $t("clientProfile.infoCard.phone.label") }}</label>
						<span>{{ client.phone }}</span>
					</div>
					<div class="bb-client-profile-info-item">
						<label>{{ $t("clientProfile.infoCard.notes.label") }}</label>
						<span>{{ client.notes }}</span>
					</div>
					<div class="bb-client-profile-info-item">
						<label>{{
              $t("clientProfile.infoCard.notifications.label")
            }}</label>
						<span>{{
              client.notificationsEnabled
                ? $t("clientProfile.infoCard.notifications.enabledLabel")
                : $t("clientProfile.infoCard.notifications.disabledLabel")
            }}</span>
					</div>
					<div v-if="client.notificationsEnabled == true" class="bb-client-profile-info-item">
						<label>{{
              $t("clientProfile.infoCard.notifications.viaLabel")
            }}</label>
						<span>{{
              client.notificationsSentBy == "email"
                ? $t("clientProfile.infoCard.notifications.emailLabel")
                : $t("clientProfile.infoCard.notifications.unknownLabel")
            }}</span>
					</div>
				</div>
			</div>
			<!-- Right section -->
			<div class="bb-client-profile-details-section">
				<div class="bb-card">
					<div class="d-flex justify-content-between align-items-center">
						<div class="bb-client-profile-sales-icon">
							<svg width="29" height="24" viewBox="0 0 29 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M26.5694 0.878286C25.1756 0.311943 23.3634 0 21.4668 0C19.5702 0 17.758 0.311943 16.3642 0.878286C15.5405 1.21297 14.9117 1.622 14.5 2.08097C14.0883 1.622 13.4595 1.21303 12.6358 0.878343C11.242 0.311943 9.42981 0 7.5332 0C5.63659 0 3.82443 0.311943 2.43062 0.878286C0.863203 1.5152 0 2.42091 0 3.42857V17.1429C0 18.1505 0.863203 19.0562 2.43062 19.6931C3.72695 20.2199 5.38528 20.5262 7.13672 20.5665V20.5714C7.13672 22.5261 10.3022 24 14.5 24C18.6978 24 21.8633 22.5261 21.8633 20.5714V20.5665C23.6147 20.5262 25.273 20.2199 26.5694 19.6931C28.1368 19.0562 29 18.1505 29 17.1429V3.42857C29 2.42091 28.1368 1.5152 26.5694 0.878286ZM27.8672 13.7143C27.8672 14.2021 27.2077 14.7731 26.1462 15.2045C24.9972 15.6713 23.4547 15.9538 21.8633 15.9943V13.7143C21.8633 13.7126 21.8632 13.711 21.8632 13.7094C23.6147 13.6691 25.273 13.3628 26.5694 12.836C27.0782 12.6293 27.5123 12.3941 27.8672 12.1363L27.8672 13.7143ZM13.9336 6.85714C13.9336 7.34497 13.2741 7.91594 12.2126 8.34731C10.9683 8.85291 9.26278 9.14286 7.5332 9.14286C5.80363 9.14286 4.09806 8.85291 2.85384 8.34731C1.79228 7.91594 1.13281 7.34497 1.13281 6.85714V5.2792C1.48778 5.53691 1.92182 5.77211 2.43062 5.97886C3.82443 6.5452 5.63659 6.85714 7.5332 6.85714C9.42981 6.85714 11.242 6.5452 12.6358 5.97886C13.1446 5.77211 13.5786 5.53691 13.9336 5.2792V6.85714ZM2.43062 9.40743C3.82443 9.97377 5.63659 10.2857 7.5332 10.2857C9.42981 10.2857 11.242 9.97377 12.6358 9.40743C13.1446 9.20069 13.5786 8.96549 13.9336 8.70777V10.2958C12.4683 10.3459 11.063 10.5885 9.92644 10.9923C8.78643 11.3974 7.96611 11.9376 7.52001 12.5713C5.79496 12.5698 4.09489 12.2802 2.85384 11.7759C1.79228 11.3445 1.13281 10.7735 1.13281 10.2857V8.70777C1.48778 8.96549 1.92182 9.20069 2.43062 9.40743ZM1.13281 12.1363C1.48778 12.3941 1.92182 12.6293 2.43062 12.836C3.72701 13.3627 5.38539 13.669 7.13689 13.7094C7.13689 13.711 7.13678 13.7127 7.13678 13.7143V15.9943C5.54534 15.9538 4.00285 15.6713 2.85389 15.2045C1.79228 14.7731 1.13281 14.2021 1.13281 13.7143V12.1363ZM8.32946 13.4335C8.74922 12.448 11.172 11.4286 14.5 11.4286C17.828 11.4286 20.2508 12.448 20.6701 13.4324C20.7108 13.5285 20.7305 13.6206 20.7305 13.7143C20.7305 14.2167 20.1165 14.7747 19.0882 15.207C17.8718 15.7184 16.2423 16 14.5 16C12.7577 16 11.1282 15.7184 9.91183 15.207C8.88346 14.7747 8.26953 14.2167 8.26953 13.7143C8.26953 13.6206 8.2893 13.5285 8.32946 13.4335ZM27.8672 10.2857C27.8672 10.7735 27.2077 11.3445 26.1462 11.7759C24.9052 12.2802 23.2052 12.5698 21.4802 12.5713C21.0344 11.9379 20.214 11.3975 19.0736 10.9923C17.937 10.5885 16.5317 10.3459 15.0664 10.2958V8.70777C15.4214 8.96549 15.8554 9.20069 16.3642 9.40743C17.758 9.97377 19.5702 10.2857 21.4668 10.2857C23.3634 10.2857 25.1756 9.97377 26.5694 9.40743C27.0782 9.20069 27.5122 8.96549 27.8672 8.70777V10.2857ZM27.8672 6.85714C27.8672 7.34497 27.2077 7.91594 26.1462 8.34731C24.9019 8.85291 23.1964 9.14286 21.4668 9.14286C19.7372 9.14286 18.0317 8.85291 16.7874 8.34731C15.7259 7.91594 15.0664 7.34497 15.0664 6.85714V5.2792C15.4214 5.53691 15.8554 5.77211 16.3642 5.97886C17.758 6.5452 19.5702 6.85714 21.4668 6.85714C23.3634 6.85714 25.1756 6.5452 26.5694 5.97886C27.0782 5.77211 27.5122 5.53691 27.8672 5.2792V6.85714ZM16.7874 1.9384C18.0317 1.4328 19.7372 1.14286 21.4668 1.14286C23.1964 1.14286 24.9019 1.4328 26.1462 1.9384C27.2077 2.36977 27.8672 2.94074 27.8672 3.42857C27.8672 3.9164 27.2077 4.48737 26.1462 4.91874C24.9019 5.42434 23.1964 5.71429 21.4668 5.71429C19.7372 5.71429 18.0317 5.42434 16.7874 4.91874C15.7259 4.48737 15.0664 3.9164 15.0664 3.42857C15.0664 2.94074 15.7259 2.36977 16.7874 1.9384ZM2.85384 1.9384C4.09806 1.4328 5.80363 1.14286 7.5332 1.14286C9.26278 1.14286 10.9683 1.4328 12.2126 1.9384C13.2741 2.36977 13.9336 2.94074 13.9336 3.42857C13.9336 3.9164 13.2741 4.48737 12.2126 4.91874C10.9683 5.42434 9.26278 5.71429 7.5332 5.71429C5.80363 5.71429 4.09806 5.42434 2.85384 4.91874C1.79228 4.48737 1.13281 3.9164 1.13281 3.42857C1.13281 2.94074 1.79228 2.36977 2.85384 1.9384ZM2.85384 18.633C1.79228 18.2017 1.13281 17.6307 1.13281 17.1429V15.5649C1.48778 15.8226 1.92182 16.0578 2.43062 16.2646C3.72695 16.7913 5.38528 17.0976 7.13672 17.1379V19.423C5.54529 19.3823 4.00279 19.0999 2.85384 18.633ZM19.0882 22.0642C17.8718 22.5755 16.2423 22.8571 14.5 22.8571C12.7577 22.8571 11.1282 22.5755 9.91183 22.0642C8.88346 21.6319 8.26953 21.0738 8.26953 20.5714V19.0268C8.39782 19.1205 8.53959 19.2135 8.69683 19.3053C9.5764 19.8188 10.7732 20.1986 12.1578 20.4037C12.1857 20.4078 12.2134 20.4098 12.2408 20.4098C12.5172 20.4098 12.7591 20.2054 12.8004 19.9213C12.8459 19.609 12.6318 19.3187 12.3223 19.2729C9.68996 18.883 8.26953 17.8845 8.26953 17.1429V15.5931C9.55154 16.5395 11.8145 17.1429 14.5 17.1429C17.1855 17.1429 19.4485 16.5395 20.7305 15.5931V17.1429C20.7305 17.8845 19.31 18.883 16.6777 19.2729C16.3682 19.3187 16.1541 19.609 16.1996 19.9213C16.2409 20.2054 16.4828 20.4098 16.7592 20.4098C16.7866 20.4098 16.8143 20.4078 16.8422 20.4037C18.2268 20.1986 19.4235 19.8189 20.3032 19.3053C20.4604 19.2135 20.6022 19.1205 20.7305 19.0268V20.5714C20.7305 21.0738 20.1165 21.6319 19.0882 22.0642ZM26.1462 18.633C24.9972 19.0999 23.4547 19.3823 21.8633 19.4229V17.1379C23.6147 17.0975 25.273 16.7913 26.5694 16.2645C27.0782 16.0578 27.5122 15.8226 27.8672 15.5649V17.1429C27.8672 17.6307 27.2077 18.2017 26.1462 18.633Z" fill="white" />
							</svg>
						</div>
						<div class="bb-client-profile-total-sales">
							<label>{{ $t("clientProfile.salesCard.title") }}</label>
							<!-- <span>{{ totalSales }} RSD</span> -->
							<span> 468468 RSD</span>
						</div>
					</div>
				</div>
				<div class="d-flex justify-content-between align-items-center mb-3 mt-3">
					<div class="bb-card bb-client-bookings-card">
						<label>{{ $t("clientProfile.salesCard.bookings.all") }}</label>
						<!-- <span>{{ allBookingsCount }}</span> -->
						<span>4</span>
					</div>
					<div class="bb-card bb-client-bookings-card success">
						<label>{{
              $t("clientProfile.salesCard.bookings.completed")
            }}</label>
						<!-- <span>{{ completedBookingsCount }}</span> -->
						<span>2</span>
					</div>
					<div class="bb-card bb-client-bookings-card danger">
						<label>{{ $t("clientProfile.salesCard.bookings.canceled") }}</label>
						<!-- <span>{{ canceledBookingsCount }}</span> -->
						<span>2</span>
					</div>
				</div>
				<!-- <AppointmentsList
          :client="client"
          :paginationDisabled="appointmentsPaginationDisabled"
        /> -->
			</div>
		</div>
		<!-- <div
      class="mobile-client-actions-container"
      v-show="mobileActionsVisible"
      v-click-outside="handleMobileActionsOutsideClick"
    >
      <div class="mobile-client-actions">
        <button
          class="mobile-client-action-btn"
          @click="
            editClient(client);
            hideMobileActions();
          "
        >
          {{ $t("clientProfile.mobileButtons.editBtn") }}
        </button>
        <button
          class="mobile-client-action-btn danger"
          @click="
            deleteClient();
            hideMobileActions();
          "
        >
          {{ $t("clientProfile.mobileButtons.deleteBtn") }}
        </button>
      </div>
      <button class="mobile-client-action-btn" @click="hideMobileActions">
        {{ $t("clientProfile.mobileButtons.closeBtn") }}
      </button>
    </div> -->
		<ClientFormModal ref="clientFormModal" />
		<PhysicalEntityFormModal @entityUpdated="fetchUpdates()" ref="physicalEntityFormModal"></PhysicalEntityFormModal>
		<LegalEntityFormModal @entityUpdated="fetchUpdates()" ref="legalEntityFormModal"></LegalEntityFormModal>
	</div>
</template>

<script>
import { SET_BREADCRUMB } from '@/core/services/store/breadcrumbs.module';
import { SET_ALERT_MESSAGES } from '@/core/services/store/alert.module.js';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
// import { EventBus } from '@/core/services/event-bus.js';
import httpService from '@/core/services/http.service.js';
import { mapGetters } from 'vuex';
// import AppointmentsList from "@/view/pages/components/Client/AppointmentsList.vue";
import physicalEntityFormMixin from '@/core/mixins/physicalEntityFormMixin.js';
import legalEntityFormMixin from '@/core/mixins/legalEntityFormMixin.js';
import appointmentFormMixin from '@/core/mixins/appointmentFormMixin.js';
import physicalEntityMapper from '@/core/services/helpers/physicalEntityMapper.js';
import legalEntityMapper from '@/core/services/helpers/legalEntityMapper.js';
import ClientFormModal from '@/view/layout/extras/modal/ClientFormModal.vue';
import PhysicalEntityFormModal from '@/view/layout/extras/modal/PhysicalEntityFormModal.vue';
import LegalEntityFormModal from '@/view/layout/extras/modal/LegalEntityFormModal.vue';
import BBDropdown from '@/view/content/BBDropdown.vue';

export default {
	name: 'ClientProfile',
	components: {
		BBDropdown,
		// AppointmentsList,
		ClientFormModal,
		PhysicalEntityFormModal,
		LegalEntityFormModal,
	},
	mixins: [appointmentFormMixin, physicalEntityFormMixin, legalEntityFormMixin],
	data() {
		return {
			mobileActionsVisible: false,
		};
	},
	methods: {
		/**
		 * Delete client
		 * @param {Object} client
		 * @return {void}
		 */
		deleteClient() {
			let route = '';
			if (this.clientType == 'physicalEntity') {
				route = '/api/b2b/physical-entities/';
			}
			if (this.clientType == 'legalEntity') {
				route = '/api/b2b/legal-entities/';
			}

			httpService
				.delete(route + this.client.id)
				.then((response) => {
					this.$store.dispatch(SET_ALERT_MESSAGES, {
						successMessages: [response.data.message],
						errorMessages: null,
					});
					this.$router.push({ name: 'clients' });
				})
				.catch((error) => {
					this.$store.dispatch(SET_ALERT_MESSAGES, {
						successMessages: null,
						errorMessages: [error.response.data.message],
					});
				});
		},

		/**
		 * Dispatch a call to fetch updates after event is emmited in entity form modal
		 */
		fetchUpdates() {
			if (this.clientType == 'physicalEntity') {
				this.$store.dispatch('getPhysicalEntity', {
					id: this.client.id,
				});
				return;
			}
			this.$store.dispatch('getLegalEntity', {
				id: this.client.id,
			});
		},

		/**
		 * Show mobile client actions
		 * @return {void}
		 */
		showMobileActions() {
			this.mobileActionsVisible = true;
			this.$emit('toggle-overlay');
			let targetElement = document.querySelector('.mobile-client-actions-container');
			disableBodyScroll(targetElement);
		},

		/**
		 * Hide mobile client actions
		 * @return {void}
		 */
		hideMobileActions() {
			this.mobileActionsVisible = false;
			this.$emit('toggle-overlay');
			let targetElement = document.querySelector('.mobile-client-actions-container');
			enableBodyScroll(targetElement);
		},

		/**
		 * Handle click outside of mobile actions element
		 * @param {Object} event
		 * @return {void}
		 */
		handleMobileActionsOutsideClick(event) {
			if (event.target.classList.contains('offcanvas-overlay') && this.mobileActionsVisible) {
				this.hideMobileActions();
			}
		},
	},
	mounted() {
		// Dispatch store SET_BREADCRUMB action to set page title
		this.$store.dispatch(SET_BREADCRUMB, [{ title: this.$t('clientProfile.title') }]);

		// Dispatch store client action based on url
		this.$route.params.entity == 'physical-entities'
			? this.$store.dispatch('getPhysicalEntity', {
					id: this.$route.params.id,
			  })
			: this.$store.dispatch('getLegalEntity', {
					id: this.$route.params.id,
			  });
	},
	computed: {
		...mapGetters(['physicalEntity', 'legalEntity']),

		/**
		 * Return client to display based on client type
		 * @return {Array}
		 */
		client() {
			if (this.$route.params.entity == 'physical-entities') {
				return this.physicalEntity;
			}
			if (this.$route.params.entity == 'legal-entities') {
				return this.legalEntity;
			}
			return [];
		},

		/**
		 * Return client type based on route
		 *
		 * @return {String}
		 */
		clientType() {
			if (this.$route.params.entity == 'physical-entities') {
				return 'physicalEntity';
			}
			if (this.$route.params.entity == 'legal-entities') {
				return 'legalEntity';
			}
			return null;
		},
	},
	// Create local state store
	beforeCreate() {
		this.$store.registerModule('ClientProfile', {
			state: {
				physicalEntity: null,
				legalEntity: null,
			},
			getters: {
				physicalEntity: (state) => state.physicalEntity,
				legalEntity: (state) => state.legalEntity,
			},
			actions: {
				getPhysicalEntity(context, { id }) {
					httpService.get(`/api/b2b/physical-entities/${id}`).then((response) => {
						context.commit('setPhysicalEntity', response.data.data);
					});
				},
				getLegalEntity(context, { id }) {
					httpService.get(`/api/b2b/legal-entities/${id}`).then((response) => {
						context.commit('setLegalEntity', response.data.data);
					});
				},
			},
			mutations: {
				setPhysicalEntity(state, data) {
					state.physicalEntity = physicalEntityMapper.mapPhysicalEntity(data);
				},
				setLegalEntity(state, data) {
					state.legalEntity = legalEntityMapper.mapLegalEntity(data);
				},
			},
		});
	},
	beforeDestroy() {
		this.$store.unregisterModule('ClientProfile');
	},
};
</script>

<style lang="scss">
@import '@/assets/sass/bb-styles/pages/client-profile.scss';
</style>
